import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ESigningRecipientListItemComponent } from '../e-signing-recipient-list-item/e-signing-recipient-list-item.component';
import { AVATAR_VARIANT_ORDER } from '@ui/utils/constants';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClientSigningDetailsViewModelComplete } from '@models/e-signing';
import { UiModule } from '@ui/ui.module';

@Component({
	selector: 'app-e-signing-recipient-list',
	imports: [ESigningRecipientListItemComponent, ReactiveFormsModule, UiModule],
	templateUrl: './e-signing-recipient-list.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'w-full' },
})
export class ESigningRecipientListComponent {
	form = input<FormGroup>();
	submitted_ = input<boolean>(false);
	recipients = input<ClientSigningDetailsViewModelComplete[]>([]);
	AVATAR_VARIANT_ORDER = AVATAR_VARIANT_ORDER;
}
